import r from "../managers/braze-instance.js";
export function initialize(i, n) {
  return r.initialize(i, n);
}
